import { useMemo } from "react";
import { useApiClient } from "../apiClients";
import { ENDPOINTS_BILLING_ADMIN } from "./endpoints";

export type BillingAdminUserLookup = {
    ID: number;
    Login: string;
    Nom: string;
    Actif: boolean;
};

export type BillingAdminCurrentStatus = {
    Statut: string;
    Vendor: string;
    DateFin: string;
} | null;

export type BillingAdminLookupResult = {
    User: BillingAdminUserLookup;
    Current: BillingAdminCurrentStatus;
};

export type BillingAdminGrantResult = {
    IDBilling: number;
    Statut: string;
    Vendor: string;
    ExpirationDate: string;
};

export const useBillingAdminApi = () => {
    const client = useApiClient("tilmicode");

    return useMemo(
        () => ({
            lookup: async (login: string): Promise<BillingAdminLookupResult> => {
                const { data } = await client.get<BillingAdminLookupResult>(ENDPOINTS_BILLING_ADMIN.LOOKUP, {
                    params: { login },
                });
                return data;
            },
            grantPremium: async (userId: number, expirationDate: string): Promise<BillingAdminGrantResult> => {
                const { data } = await client.post<BillingAdminGrantResult>(ENDPOINTS_BILLING_ADMIN.GRANT, {
                    user_id: userId,
                    expiration_date: expirationDate,
                });
                return data;
            },
        }),
        [client]
    );
};
